import UserConstants from './../constants/UserConstants';
import context from './../context';

type UserActionsEvent = {
  type: (typeof UserConstants)[keyof typeof UserConstants];
  options?: unknown;
  callback?: unknown;
};

function dispatch(event: UserActionsEvent) {
  setTimeout(() => {
    context.getDispatcher().dispatch(event);
  }, 0);
}

class UserActions {
  loginWithGoogle(options, callback) {
    dispatch({
      type: UserConstants.USER_LOGIN_WITH_GOOGLE,
      options: options,
      callback: callback,
    });
  }

  updateProfile(data, callback) {
    dispatch({
      type: UserConstants.USER_UPDATE_PROFILE,
      options: {
        data: data,
      },
      callback: callback,
    });
  }

  logout(callback) {
    dispatch({
      type: UserConstants.USER_LOGOUT,
      callback: callback,
    });
  }
}

export default new UserActions();
